module.exports = __webpack_public_path__ + "img/big_1_79.168dd59e.png";